import createAsyncActionType from '../utilities/createAsyncActionType';

export const LOGOUT_USER = createAsyncActionType('LOGOUT_USER');


// WEBPACK FOOTER //
// ./src/types/logoutUserTypes.js